import React, { useState, useEffect } from "react";
import NavTagline from "../../components/nav-tagline/nav-tagline";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import EulaActionBox from "./EULAActionBox";
import Copyright from "../shared/Copyright";

const EulaDefault = () => {
  const [processing] = useState(false);

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
  let timer;
  if (processing) {
    timer = setTimeout(() => {
      setLoadingText("Working on it...");
    }, 10000);
  } else {
    setLoadingText("Loading...");
  }

  return () => clearTimeout(timer); 
  }, [processing]);

  return (
    <div className="Eula">
      <NavTagline />
      <main className="layout-container" aria-labelledby="eulaHeading">
        <div className="container">
          <h1 className="text-size5 blk-clr" id="eulaHeading">Standard Terms</h1>
          <p>
            These standard terms apply to your access to and use of certain
            products and services provided by Centauri Health Solutions, Inc.
            ("CHS") and its subsidiaries, SecureEx Solutions, Inc. dba Secure
            Exchange Solutions Inc. ("SES") and Medallies, Inc. ("Medallies"
            together with CHS and SES, collectively, "Centauri") through this
            site (the Products). Your use of the Products are subject to the
            applicable Master SaaS Subscription Agreement ("MSSA") or Health
            Information Service Provider Subscription Agreement with SES, or
            the Direct Network Services Connectivity Agreement with Medallies,
            or other agreement with Centauri for your or your organization's
            use of the Products (each, an "Existing Agreement") and the terms
            and conditions of the applicable Existing Agreement are the only
            terms which apply to your use of the applicable product and
            services contracted for and licensed under your Existing Agreement.
            The applicable Existing Agreement may be between your organization
            and a third party which entered into such Existing Agreement for
            use of the Products. Your use of the Products, including any costs
            associated with use of the Products, is subject solely to the
            applicable Existing Agreement including any Business Associate
            Agreement entered into in connection with the applicable Existing
            Agreement.
          </p>
          <p>
            Unless your use of the Products and Services is subject to an
            Existing Agreement, the Products and Services are provided "as-is"
            and "where-is" without any other warranties, express or implied,
            regarding or concerning the Products or the results or output
            produced by the Products and except as otherwise provided in these
            Standard Terms, there are no other warranties of any kind, express
            or implied, including, without limitation, warranties of
            merchantability and fitness for any particular purpose. No
            representation or other affirmation of fact by anyone shall be
            deemed to be or create a warranty from Centauri or any of its
            licensors, vendors, or suppliers, or by anyone else who has been
            involved in the creation, production, or delivery of the Products.   
          </p>
          
          <EulaActionBox />
        </div>
      </main>

      <div className="ses_footer">
        <div className="ses-footer animate slide delay-2">
          <footer role="contentinfo">
            <div className="ses-footer-container">
              <div
                className="ses-directTrust"
                aria-label="Direct Trust Certification: DTAAP HISP DTAAP CA DTAAP RA"
                role="img"
              >
              </div>
            </div>
            <div className="right-container">
              <div className="poweredby-aws">
                <a
                  href="http://hitrustalliance.net"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img
                    src={HiTrustLogo}
                    className="hitrust-img"
                    alt="HITRUST CSF Certified"
                  />
                </a>
                <img
                  src={PoweredByAWS}
                  alt="Powered by AWS"
                />
              </div>
              <div className="contact-footer">
                <strong>Technical Support:</strong> <a href="tel:18884709913" aria-label="Call Technical Support at 1 888 470 9913">1.888.470.9913</a>{" "} <span aria-hidden="true">|</span>{" "}
                <a href="mailto:support@secureexsolutions.com" aria-label="Email support at support@secureexsolutions.com">
                  support@secureexsolutions.com
                </a>
              </div>
              <Copyright />
            </div>
          </footer>
        </div>
      </div>
      {processing && (
        <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="eula-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="eula-loader">{loadingText}</div>
        </div>
        )}
    </div>
  );
};

export default EulaDefault;
